export const notStarted = "NotStarted";
export const started = "Started";
export const late = "late";
export const submitted = "Submitted";
export const rejected = "Rejected";
export const resubmitted = "Resubmitted";
export const scored = "Scored";
export const completed = "Completed";
export const NoQuestionsAnswer = "NoQuestionsAnswer";
export const SomeQuestionsAnswered = "SomeQuestionsAnswered";
export const AllQuestionsAnswered = "AllQuestionsAnswered"